import React, {Component} from 'react';
import {
  Container,
  Divider,
  // Grid,
  Header,
  Image,
}                         from 'semantic-ui-react';
import _                  from 'lodash';
import ReactHtmlParser    from 'react-html-parser';
import PropTypes          from 'prop-types';

// Global
import getMessage         from '../../global/getMessage';
// Controller
import globalController   from '../../global/globalcontroller';
// Images
import choirmini          from '../../images/choirmini.jpg';
// import mommyme1           from '../../images/mommyme1.jpg';
// import mommyme2           from '../../images/mommyme2.jpg';
// Style
import                    '../MainStyle/MainTwo.scss';
import                    './MainChoir.scss';

const propTypes = {
  content : PropTypes.arrayOf(PropTypes.object),
  lang    : PropTypes.shape({menu: PropTypes.object}),
};
const defaultProps = {
  content : null,
  lang    : {},
};

class MainChoir extends Component {

  render() {
    const {lang} = this.props;
    const contentMsg = this.props.content || getMessage('section.choir.content', lang);
    const content = [];

    _.forOwn(contentMsg, (value, key) => {
      content.push(
        <p key={key}>
          {value}
        </p>
      );
    });

    return (
      <Container className='sgr-mainHome-grid-two-sub'>

        <Divider hidden />

        <Header
          as='h2'
          color='grey'
          inverted
          textAlign='center'
        >
          <Header.Content>

            <Image
              avatar
              size='small'
              src={choirmini}
            />
            {ReactHtmlParser(getMessage('menu.choir', lang))}
          </Header.Content>
        </Header>

        {content}

        {/* <Grid divided='vertically'> */}
        {/* <Grid.Row columns={2}> */}
        {/* <Grid.Column> */}
        {/* <Image src={mommyme1} /> */}
        {/* </Grid.Column> */}
        {/* <Grid.Column> */}
        {/* <Image src={mommyme2} /> */}
        {/* </Grid.Column> */}
        {/* </Grid.Row> */}
        {/* </Grid> */}

      </Container>
    );
  }

}

MainChoir.propTypes = propTypes;
MainChoir.defaultProps = defaultProps;

export default globalController(MainChoir);



// WEBPACK FOOTER //
// ./src/organisms/MainChoir/MainChoir.js